import type { WithYHistoryOptions } from '@slate-yjs/core';
import { withYHistory } from '@slate-yjs/core';

import type { LocalHistoryEditor, LocalHistoryRequiredEditor } from './local-history-editor';

export type CreateWithLocalHistoryOptions = Pick<WithYHistoryOptions, 'captureTimeout'>;

export function createWithLocalHistory(opts: CreateWithLocalHistoryOptions = {}) {
  return <T extends LocalHistoryRequiredEditor>(editor: T) => {
    const e = withYHistory(editor, opts) as T & LocalHistoryEditor;

    e.__localHistoryEditor = true;

    const { isLocalModificationOrigin } = e;
    e.isLocalModificationOrigin = origin =>
      isLocalModificationOrigin(origin) || origin === e.undoManager;

    return e;
  };
}
